// @flow
import React from "react";
import { append, without } from "ramda";

import { type Id } from "../../model";

import "./CheckboxGroup.css";

type Props = {
  className?: string,
  nome: ?string,
  itens: Array<any>,
  campoId: string,
  campoDescricao: string,
  onChange: (Array<Id>) => any,
  itensSelecionados?: Array<Id>,
};

function CheckboxGroup({
  className = "CheckboxGroup",
  nome,
  itens,
  campoId,
  campoDescricao,
  itensSelecionados = [],
  onChange,
}: Props) {
  return (
    <>
      {itens.map(item => {
        return (
          <div
            className={`CheckboxGroup ${className}`}
            key={`checkbox${nome + item[campoId]}`}
          >
            <label className="CheckboxGroup__label">
              <input
                className="CheckboxGroup__input"
                type="checkbox"
                name={nome}
                value={item[campoId]}
                onChange={event =>
                  onChange(
                    event.target.checked
                      ? append(item[campoId], itensSelecionados)
                      : without([item[campoId]], itensSelecionados)
                  )
                }
                checked={itensSelecionados.includes(item[campoId])}
              />
              <span className="CheckboxGroup__descricao">
                {item[campoDescricao]}
              </span>
            </label>
          </div>
        );
      })}
    </>
  );
}

CheckboxGroup.defaultProps = {
  className: "CheckboxGroup",
  campoId: "id",
  campoDescricao: "chaveTraducao",
};

export default CheckboxGroup;
